/* eslint-disable i18next/no-literal-string */
import React from "react";

import { Box, Card, Image, Text } from "@mantine/core";

import { TitleContent, GoToArticleIcon } from "./title-cont";

import type {
  StandardFeedCard,
  IterableInAppValues,
} from "src/typings/parentapp-feed-types";

interface StandardTitleProps {
  content: StandardFeedCard["content"];
  iterableValues: IterableInAppValues;
  hasArticle: boolean;
  isAssociatedWithPlayer: boolean;
}

export const StandardTitleCard: React.FC<StandardTitleProps> = (props) => {
  const { content, iterableValues } = props;

  const linesOfText = iterableValues.mobileInboxBody.split("\n") ?? [];

  return (
    <Box mt="md">
      <Card shadow="sm" padding="lg" radius="md" withBorder pb="xl">
        {content.image?.url ? (
          <Card.Section>
            <Image src={content.image.url} alt="Norway" />
          </Card.Section>
        ) : null}

        <Card.Section pb="sm" px="sm">
          <TitleContent
            copy={iterableValues.mobileInboxTitle}
            iconURL={iterableValues.mobileInboxIconURL}
            playerInitials={props.isAssociatedWithPlayer ? "AP" : ""}
          />
        </Card.Section>

        {/* maiun text underneath */}
        <Card.Section px="sm">
          {linesOfText.map((t, idx) => {
            return t ? (
              <Text size="sm" key={idx}>
                {t}
              </Text>
            ) : (
              <br key={idx} />
            );
          })}
        </Card.Section>

        {/* 'view article' button */}
        <GoToArticleIcon isVisible={props.hasArticle} />
      </Card>
    </Box>
  );
};
